export class Money {
	public value: number = undefined
	public currency: string = "EUR"
}



// WEBPACK FOOTER //
// ./src/app/models/money.model.ts